import { render, staticRenderFns } from "./TabelaBacklogTarefaInterrupcaoComponent.vue?vue&type=template&id=5e1a7c09"
import script from "./TabelaBacklogTarefaInterrupcaoComponent.vue?vue&type=script&lang=js"
export * from "./TabelaBacklogTarefaInterrupcaoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports